<img
  class="info-icon c-p"
  src="./assets/icons/info.svg"
  alt=""
  pTooltip='You can enter in the "Address" field and Google Address will autosuggest the required fields, or you can modify the address as needed. You can also manually add into the respective address fields as provided if you want to skip the google auto suggest.'
/>
